import { Component, OnInit, Inject, HostListener, ViewChild } from '@angular/core';
import { SharedService } from "../../shared.service";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from "angularx-social-login";
import { FacebookLoginProvider, GoogleLoginProvider } from "angularx-social-login";
import { AuthenticationService } from '../../authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { DOCUMENT } from '@angular/common';
import { HeaderService } from './header.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  closeResult: string;
  user: any;
  loggedIn: any;
  returnUrl: any;
  currentUser: User;
  searchText: string;
  user_from: string;
  mobileView: boolean=false;
  @ViewChild('mymodal') loginModalRef;
  loginModal: any;
  blogClicked: Boolean = false;
  token: string;

  login: boolean = true;
  signup: boolean = false;
  forgotpassword: boolean = false;

  public lat;
  public lng;
  
  constructor(
    private sharedService: SharedService,
    private modalService: NgbModal,
    private authService: AuthService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private headerService: HeaderService,
    @Inject(DOCUMENT) private document: Document
  ) { }
  categories = []

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (document.body.scrollTop > 100 ||
      document.documentElement.scrollTop > 100) {
      document.getElementById('mainNav').classList.add('navbar-shrink');
    }
    else {
      document.getElementById('mainNav').classList.remove('navbar-shrink');

    }
  }

  signInWithGoogle(): void {
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  signInWithFB(): void {
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
    // this.loginToServer();
  }



  fbSignOut(): void {
    this.authService.signOut();
  }

  logOut(): void {
    this.authenticationService.logout();
    this.authService.signOut();
  }

  ngOnInit(): void {
    this.sharedService.getCategories().subscribe((data) => {
      this.categories = data['results'];
      this.sharedService.setCategoriesData(data);
    });
    this.activateRoute.queryParams.subscribe(params => {
      this.returnUrl = params['returnUrl'];
      this.user_from = params['from'];
      if(this.user_from){
        this.headerService.setUserFromSession(this.user_from);
      }
    });

    this.headerService.showLogin.subscribe((open:boolean)=>{
      if(open){
          this.loginModal = this.modalService.open(this.loginModalRef, { centered: true, windowClass: 'dark-modal exceed-limit login-modal' })

      } else{
        try {
          this.loginModal.close();

        } catch (error) {
          console.log(error);
        }
      }
    })

    this.authService.authState.subscribe((user) => {
      if (user && !this.authenticationService.currentUserValue) {
        this.loginToServer(user, user.photoUrl, this.token);
      }
    });
    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
    if (window.screen.width <= 991) { // 768px portrait
      this.mobileView = true;
    }else{
      this.mobileView = false;

    }
    this.getLocation();
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: Position) => {
        if (position) {
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;
        }
      },
        (error: PositionError) => console.log(error));
    } else {
      // alert("Geolocation is not supported by this browser.");
    }
  }

  refreshComponent(){
    // this.router.navigateByUrl('/search', { skipLocationChange: true }).then(() => {
    // this.router.navigate(['SearchComponent']);
    // });
  }

  open(content: any) {
    this.loginModal = this.modalService.open(content, { centered: true, windowClass: 'dark-modal exceed-limit login-modal' })
  }

  openClose() {
    this.loginModal.close();
  }

  loginClicked(open:boolean){
    this.headerService.setLoginModalValue(open);
  }

  loginToServer(user: any = null, photoUrl: string, token: string) {
    this.authenticationService.login(user.provider.toLowerCase(), user.id,
    user.authToken, user.email, user.firstName, user.lastName,
    photoUrl, this.lat, this.lng, token)
      .subscribe(
        (_data) => {
          if (this.returnUrl) {
            this.router.navigate([this.returnUrl]);
          }
          this.loginModal.close();

        }
      );
  }

  goToSearch() {
    if (this.searchText) {
      localStorage.setItem('2dDetails', JSON.stringify({ nameValue: '2d'}));
      const searchText = this.searchText;
      this.searchText = '';
      this.router.navigate(['search'], { queryParams: { search: searchText } });
    }
  }

  loadDataOnly(value: string){
    localStorage.setItem('2dDetails', JSON.stringify({ nameValue: value}));
  }
}
